import { FC, ReactNode } from 'react';
import { Tooltip } from 'shared/components/Tooltip/Tooltip';
import { InfoIcon } from 'shared/icons';
import { mergeClasses } from 'shared/utils/mergeClasses';

interface InputLabelProps {
  children: ReactNode;
  tooltipId?: string;
  infoTooltipContent?: string;
  className?: string;
}

export const InputLabel: FC<InputLabelProps> = ({
  children,
  tooltipId,
  infoTooltipContent,
  className = '',
}) => {
  return (
    <p className={mergeClasses('mb-1 flex items-center text-sm', className)}>
      {children}
      {infoTooltipContent && tooltipId && (
        <Tooltip message={infoTooltipContent} id={tooltipId}>
          <InfoIcon className="ml-1 h-5 w-5 text-black" />
        </Tooltip>
      )}
    </p>
  );
};
